import { computed, ref, readonly } from "#imports";
import definitions from "#blokkli-build/definitions";
import {
  OPTIONS
} from "#blokkli-build/runtime-options";
export default function() {
  const blocks = ref(definitions.blocks);
  const fragments = ref(definitions.fragments);
  const renderKey = ref(definitions.renderKey);
  const blockIcons = ref(definitions.icons);
  const allGlobalOptions = ref(
    definitions.globalOptions
  );
  const runtimeOptions = ref(OPTIONS);
  if (import.meta.hot) {
    import.meta.hot.accept("#blokkli-build/definitions", (mod) => {
      const newDefinitions = mod;
      renderKey.value = newDefinitions?.default.renderKey || "";
      blocks.value = newDefinitions?.default?.blocks || [];
      fragments.value = newDefinitions?.default?.fragments || [];
      blockIcons.value = newDefinitions?.default?.icons || {};
      allGlobalOptions.value = newDefinitions?.default?.globalOptions || {};
    });
    import.meta.hot.accept("#blokkli-build/runtime-options", (mod) => {
      if (mod?.OPTIONS) {
        runtimeOptions.value = mod.OPTIONS;
      }
    });
  }
  const blocksByKey = computed(
    () => blocks.value.reduce((acc, definition) => {
      const bundle = definition.bundle;
      const renderForValue = definition.renderFor || [];
      const renderForList = Array.isArray(renderForValue) ? renderForValue : [renderForValue];
      if (renderForList.length) {
        renderForList.forEach((renderFor) => {
          if ("parentBundle" in renderFor) {
            acc[bundle + "__parent:" + renderFor.parentBundle] = definition;
          } else if ("fieldList" in renderFor) {
            acc[bundle + "__field:" + renderFor.fieldList] = definition;
          } else if ("fieldListType" in renderFor) {
            acc[bundle + "__field:" + renderFor.fieldListType] = definition;
          }
        });
      } else {
        acc[bundle] = definition;
      }
      return acc;
    }, {})
  );
  const fragmentsByName = computed(
    () => fragments.value.reduce(
      (acc, definition) => {
        acc[definition.name] = definition;
        return acc;
      },
      {}
    )
  );
  function getBlockDefinition(bundle, fieldListType, parentBundle) {
    const forFieldListType = bundle + "__field:" + fieldListType;
    if (blocksByKey.value[forFieldListType]) {
      return blocksByKey.value[forFieldListType];
    }
    if (parentBundle) {
      const forParentBundle = bundle + "__parent:" + parentBundle;
      if (blocksByKey.value[forParentBundle]) {
        return blocksByKey.value[forParentBundle];
      }
    }
    return blocksByKey.value[bundle];
  }
  function getFragmentDefinition(name) {
    return fragmentsByName.value[name];
  }
  function getDefaultDefinition(bundle) {
    return blocksByKey.value[bundle];
  }
  function getBlockIcon(bundle) {
    return blockIcons.value[bundle];
  }
  return {
    getBlockDefinition,
    getFragmentDefinition,
    getDefaultDefinition,
    getBlockIcon,
    fragmentDefinitions: computed(() => fragments.value),
    blockDefinitions: computed(() => blocks.value),
    globalOptions: readonly(allGlobalOptions),
    runtimeOptions: readonly(runtimeOptions),
    renderKey: readonly(renderKey)
  };
}
if (import.meta.hot) {
  import.meta.hot.accept();
}
